/* ***************************************
This mixin "exposes" the methods:
  * rewriteWordOrWordsInWorkingArrayMethod() [for EditNikudPane, ManualNikudPane, NikudOptionsPane, NikudEdit]
  * spliceWordsInWorkingArrayMethod() [for EditNikudPane]
  * changeAllAlikeWordsToNewNikud() [for ManualNikudPane and NikudOptionsPane]
It has the "common dependency" methods:
  * rewriteWordOrWordsInWorkingArrayMethod() [exposed (as above), AND used by the resultsIntegrationMixins method
                                        clearNikudEffectiveImmediately(), which is both "exposed" (for
                                        NikudEdit) AND used by its own internal method
                                        getWordsArrayFromNakdanResponse(), in turn used by its own methods
                                        populateAllWorkingNikud() (used by NikudEdit) and 
                                        finishEditingWordGroup() (used by EditNikudPane and ManualNikudPane)]
  * spliceWordsInWorkingArrayMethod() [exposed (as above), AND used by the resultsIntegrationMixins method
                                        finishEditingWordGroup() (used by EditNikudPane and ManualNikudPane)]
(all else should be considered "internal")
*************************************** */
// import {getChosenWordString} from '../js/letterOperations';

export default {
  name: 'wordMutatingMixins',
  methods: {
    rewriteWordOrWordsInWorkingArrayMethod (commitObjectOrObjects) {
      const commitObjects = Array.isArray(commitObjectOrObjects) ? commitObjectOrObjects : [commitObjectOrObjects]
      commitObjects.forEach(commitObj => {
        // console.log('commitObj:')
        // console.log(commitObj)
        this.$store.commit('REWRITE_WORD_IN_WORKING_ARRAY', commitObj)
        this.modesObj.wordMutationCount += 1 // so panes can re-initialize
      })
    },
    spliceWordsInWorkingArrayMethod (commitObj) {
      // console.log('commitObj:')
      // console.log(commitObj)
      this.$store.commit('SPLICE_WORDS_IN_WORKING_ARRAY', commitObj)
      this.modesObj.wordMutationCount += 1 // so panes can re-initialize
    },
    changeAllAlikeWordsToNewNikud () {
      const wordsToChange = this.getAllAlikeWordsToChange()
      if (wordsToChange.length) this.rewriteWordOrWordsInWorkingArrayMethod(wordsToChange)
      this.showApplyToAllPopup = false
      return wordsToChange.length
    }
  }
}
